if (!customElements.get("custom-toggle-product")) {
  customElements.define(
    "custom-toggle-product",
    class CustomToggleProduct extends HTMLElement {
      constructor() {
        super();
        // removed when we removed the option to purchase the Duet
        // this.buttons = this.querySelectorAll("button.product-model-btn");
        this.atcButton = this.querySelector(".bundle-btn");
        this.bundleIds = this.dataset.bundleIds;
        // removed when we removed the option to purchase the Duet
        // this.selectedMachineId = this.querySelector(
        //   "button.product-model-btn.selected"
        // ).getAttribute("data-product-id");
        this.selectedMachineId = "15685587206193"; // hardcoded when we removed the option to purchase the Duet
        this.selectedCapsule = this.querySelector("select").value;
        this.sideCart = document.querySelector("side-cart");
        this.init();
      }

      init() {
        // removed when we removed the option to purchase the Duet
        // this.buttons.forEach((button) =>
        //   button.addEventListener("click", this.selectProductId.bind(this))
        // );

        if (!this.atcButton) return;
        
        this.atcButton.addEventListener("click", this.addBundleProd.bind(this));
      }

      connectedCallback() {
        this.addEventListener("change", this.updateBundles);
      }

      selectProductId(e) {
        // removed when we removed the option to purchase the Duet
        // this.buttons.forEach((btn) => btn.classList.remove("selected"));
        // e.target.classList.add("selected");
        // const selectedMachineId = e.target.getAttribute("data-product-id");
        
        // hardcoded when we removed the option to purchase the Duet
        const selectedMachineId = this.selectedMachineId;

        this.updatePriceByMachineSelection(selectedMachineId);
        this.syncCapsules(selectedMachineId);
        this.updateCarousel(selectedMachineId);
        this.updateReviewsBadge(selectedMachineId);
      }

      updatePriceByMachineSelection(selectedMachineId) {
        const bundlePriceWithoutDiscounts = [
          ...document.querySelectorAll(".bundle-price-without-discount"),
        ];

        const bundlePriceWithDiscounts = [
          ...document.querySelectorAll(".bundle-price-with-discount"),
        ];

        let data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        let machinePrice;
        let preselectedCommonCapsulesPrice;

        if (isClassicCollectionVariety6Capsules) {
          if (selectedMachineId === "15685587206193") {
            preselectedCommonCapsulesPrice = data
              .find((p) => p.handle === "classic-cocktails-collection")
              .variants.find((variant) => variant.title === "6 Capsules").price;
          } else if (selectedMachineId === "42837907636423") {
            preselectedCommonCapsulesPrice = data
              .find((p) => p.handle === "margarita-cocktails")
              .variants.find((variant) => variant.title === "8 Capsules").price;
          } else {
            return;
          }
        } else {
          preselectedCommonCapsulesPrice = data
            .find((p) => p.handle === "margarita-cocktails")
            .variants.find((variant) => variant.title === "8 Capsules").price;
        }

        if (selectedMachineId === "15685587206193") {
          machinePrice = data.find((p) => p.handle === "the-bartesian").price;
        } else if (selectedMachineId === "42837907636423") {
          machinePrice = data.find((p) => p.handle === "bartesian-duet-cocktail-maker").price;
        } else {
          return;
        }

        const updatedBundlePrice = ((machinePrice + preselectedCommonCapsulesPrice) / 100).toFixed(
          2
        );

        bundlePriceWithoutDiscounts.forEach(
          (price) => (price.textContent = "$" + updatedBundlePrice)
        );
        bundlePriceWithDiscounts.forEach(
          (price) => (price.textContent = "$" + (machinePrice / 100).toFixed(2))
        );
      }

      syncCapsules(machineId) {
        const capsulesDropdown = this.querySelector("#bundle-promo-capsules");
        let capsulesData = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        if (machineId === "15685587206193") {
          capsulesData = capsulesData.slice(2);
          renderCapsuleSelection(capsulesData);
        } else if (machineId === "42837907636423") {
          capsulesData = capsulesData.slice(3);
          renderCapsuleSelection(capsulesData);
        } else {
          return;
        }

        function renderCapsuleSelection(capsulesData) {
          capsulesDropdown.innerHTML = `
            <select class="select__select" id="bundle-promo-capsules">
              <option value="" disabled>Select Capsules</option>
              ${capsulesData.map((data) => {
                let capsules;
                if (isClassicCollectionVariety6Capsules) {
                  if (data.handle === "classic-cocktails-collection") {
                    capsules = data.variants.find((variant) => variant.title === "6 Capsules");
                    // return `<option handle=${data.handle} value="${capsules.id}">${data.title} / ${capsules.title}</option>`;
                    return `<option handle=${data.handle} value="${capsules.id}">${data.title}</option>`;
                  } else {
                    capsules = data.variants.find((variant) => variant.title === "8 Capsules");
                    // return `<option handle=${data.handle} value="${capsules.id}">${data.title} / ${capsules.title}</option>`;
                    return `<option handle=${data.handle} value="${capsules.id}">${data.title}</option>`;
                  }
                } else {
                  capsules = data.variants.find((variant) => variant.title === "8 Capsules");
                  // return `<option handle=${data.handle} value="${capsules.id}">${data.title} / ${capsules.title}</option>`;
                  return `<option handle=${data.handle} value="${capsules.id}">${data.title}</option>`;
                }
              })}
            </select>
          `;
        }
      }

      updateBundles() {
        // removed when we removed the option to purchase the Duet
        // this.selectedMachineId = this.querySelector(
        //   "button.product-model-btn.selected"
        // ).getAttribute("data-product-id");

        this.selectedCapsule = this.querySelector("select").value;
        this.selectedCapsuleHandle =
          this.querySelector("select").options[
            this.querySelector("select").selectedIndex
          ].getAttribute("handle");
        this.updatePriceByCapsulesSelection(
          this.selectedMachineId,
          this.selectedCapsuleHandle,
          this.selectedCapsule
        );
      }

      async updatePriceByCapsulesSelection(
        selectedMachineId,
        selectedCapsuleHandle,
        selectedCapsulesId
      ) {
        const bundlePriceWithoutDiscounts = [
          ...document.querySelectorAll(".bundle-price-without-discount"),
        ];

        const bundlePriceWithDiscounts = [
          ...document.querySelectorAll(".bundle-price-with-discount"),
        ];

        let machinePrice;
        let selectedCapsulesPrice;
        let data = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        const response = await fetch(`/products/${selectedCapsuleHandle}.json`);
        const capsuleProductData = await response.json();

        selectedCapsulesPrice = capsuleProductData.product.variants.find(
          (variant) => variant.id === +selectedCapsulesId
        ).price;

        if (selectedMachineId === "15685587206193") {
          machinePrice = data.find((p) => p.handle === "the-bartesian").price;
        } else if (selectedMachineId === "42837907636423") {
          machinePrice = data.find((p) => p.handle === "bartesian-duet-cocktail-maker").price;
        } else {
          return;
        }

        const updatedBundlePrice = ((machinePrice + +selectedCapsulesPrice * 100) / 100).toFixed(2);

        bundlePriceWithoutDiscounts.forEach(
          (price) => (price.textContent = "$" + updatedBundlePrice)
        );
        bundlePriceWithDiscounts.forEach(
          (price) => (price.textContent = "$" + (machinePrice / 100).toFixed(2))
        );
      }

      async addBundleProd() {
        this.updateBundles();
        const bundleProductIds = [this.selectedMachineId, this.selectedCapsule];

        try {
          this.atcButton.classList.add("inprogress");

          const items = bundleProductIds.map((bundle) => {
            return {
              quantity: 1,
              id: bundle,
              properties: {},
            };
          });

          await this.sideCart.addItemsToCart(items);
          setTimeout(this.atcButton.classList.remove("inprogress"), 1000);
        } catch (err) {
          console.error(err);
        }
      }

      updateCarousel(selectedMachineId) {
        const slides = [...document.querySelectorAll(".product-thumb-slider__container")];
        slides.forEach((slide) => slide.classList.remove("hide-element"));

        if (selectedMachineId === "15685587206193") {
          slides
            .find((slide) => slide.classList.contains("duet-slider-container"))
            .classList.add("hide-element");
        } else if (selectedMachineId === "42837907636423") {
          slides
            .find((slide) => slide.classList.contains("bartesian-slider-container"))
            .classList.add("hide-element");
        } else {
          return;
        }
      }

      async updateReviewsBadge(selectedMachineId) {
        let machineProductId;
        let machineProductSku;
        let machineProductTitle;

        if (selectedMachineId === "15685587206193") {
          machineProductId = "2029008945201";
          machineProductSku = "the-bartesian";
          machineProductTitle = "The Bartesian Cocktail Maker";
        } else if (selectedMachineId === "42837907636423") {
          machineProductId = "7535183757511";
          machineProductSku = "bartesian-duet-cocktail-maker";
          machineProductTitle = "Duet Cocktail Maker";
        } else {
          return;
        }

        const response = await fetch(
          "http://stamped.io/api/widget/badges?isIncludeBreakdown=true&isincludehtml=true",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              productIds: [
                {
                  productId: machineProductId,
                },
              ],
              apiKey: "pubkey-3IGD0167irCzM4uG3I0l1mrhfLGOAj",
              storeUrl: "bartesian.com",
            }),
          }
        );

        const data = await response.json();
        const badge = data[0].badge;
        const reviewsBadge = document.querySelector(".reviewsBadge");
        reviewsBadge.innerHTML = `
          <div class="reviewsBadge">
            <span
              class="stamped-product-reviews-badge stamped-main-badge"
              data-id=${machineProductId}
              data-product-sku=${machineProductSku}
              data-product-title=${machineProductTitle}
              data-product-type="Cocktail Dispensers"
              style="display: inline-block;"
            >
              ${badge}
            </span>
          </div>
        `;

        const productReviewTemplate = `/products/${machineProductSku}?view=product-main-review`;
        const templateResponse = await fetch(productReviewTemplate);
        const templateData = await templateResponse.text();
        const stampedReviews = document.querySelector(".stamped-reviews");
        stampedReviews.innerHTML = templateData.trim();
        stampedInit(window, document);
      }
    }
  );
}
